import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      financialStatement: {
        TEXT_NOTE:
          '* Modifying settings here may impact the financial data of the company in other features.',
        FISCAL_END_YEAR: 'Fiscal Year End',
        LEGAL_REGULATION: 'Legal Regulation',
        AUDIT_STATUS: 'Audit Status',
        AUDITED: 'Audited',
        UNAUDITED: 'Unaudited',
        METHOD: 'Method',
        DIRECT: 'Direct',
        INDIRECT: 'Indirect',
        BALANCE_SHEET: 'Balance Sheet',
        INCOME_STATEMENT: 'Income Statement',
        CASH_FLOW_STATEMENT: 'Cash Flow Statement',
        RESET_FILTER: 'Recommended Filters',
        COMMON_SIZE_YOY_GROWTH: 'Common Size & YoY Growth',
        TYPE_OF_FS: 'Type of FS:',
        SINGLE_ENTITY: 'Single Entity',
        UNCONSOLIDATED: 'Separate',
        CONSOLIDATED: 'Consolidated',
        SOURCE: 'Source:',
        PUBLIC_ANNOUNCEMENT: 'Public Announcement',
        TAX_FILING: 'Tax Filing',
        CREDIT_FILING: 'Credit Filing',
        OTHER: 'Other',
        CHANGE_LEGAL_REGULATION:
          'In %{yearChange}, the Company changed its Financial Statement Presentation from Decree No %{oldReportForm} to Decree No %{newReportForm}. View FS of %{years} %{link}.',
        CHANGE_LEGAL_REGULATION_2:
          'In %{yearChange}, the Company changed its Financial Statement Presentation from Decree No %{oldReportForm} to Decree No %{newReportForm}.',
        HERE: 'this link',
        BACK_CHANGE_LEGAL_REGULATION:
          'To view Financial Statement before %{yearChange}, please click this %{link}.',
        BACK: 'Back',
        CHANGE_FISCAL_END_YEAR:
          'In %{fiscalYearEndChangeYear}, the Company has changed its fiscal year end from %{oldFiscalYearEnd} to %{newFiscalYearEnd}.',
        dynamicTable: {
          AS_AT: 'As at',
          FOR_THE_YEAR_ENDED: 'For the year ended',
          FY: 'FY',
          UNIT: 'Unit',
          AUDIT_STATUS: 'Audit Status',
          TYPE: 'Type',
          LEGAL_REGULATION: 'Legal Regulation',
          SOURCE: 'Source',
          METHOD: 'Method',
        },
        REQUEST_CONTACT_NOTE1: 'For more annual financial reports, please ',
        REQUEST_CONTACT_NOTE2: 'contact us.',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      financialStatement: {
        TEXT_NOTE:
          '* Thay đổi cài đặt tại đây có thể ảnh hưởng đến dữ liệu tài chính của công ty trong các màn hình khác.',
        FISCAL_END_YEAR: 'Năm Tài Chính',
        LEGAL_REGULATION: 'Thông Tư',
        AUDIT_STATUS: 'Tình Trạng Kiểm Toán',
        AUDITED: 'Kiểm toán',
        UNAUDITED: 'Chưa kiểm toán',
        METHOD: 'Phương Pháp',
        DIRECT: 'Trực tiếp',
        INDIRECT: 'Gián tiếp',
        BALANCE_SHEET: 'Bảng cân đối kế toán',
        INCOME_STATEMENT: 'Báo cáo kết quả hoạt động kinh doanh',
        CASH_FLOW_STATEMENT: 'Báo cáo lưu chuyển tiền tệ',
        RESET_FILTER: 'Bộ Lọc Đề Xuất',
        COMMON_SIZE_YOY_GROWTH: 'Tỷ trọng và Tăng trưởng qua từng năm',
        TYPE_OF_FS: 'Loại báo cáo tài chính:',
        SINGLE_ENTITY: 'Riêng lẻ',
        UNCONSOLIDATED: 'Riêng lẻ',
        CONSOLIDATED: 'Hợp nhất',
        SOURCE: 'Nguồn:',
        PUBLIC_ANNOUNCEMENT: 'Công Bố Thông Tin',
        TAX_FILING: 'Kê Khai Thuế',
        CREDIT_FILING: 'Kê Khai Tín Dụng',
        OTHER: 'Khác',
        CHANGE_LEGAL_REGULATION:
          'Năm %{yearChange}, Công ty đã thay đổi cách ghi nhận Báo cáo tài chính từ thông tư %{oldReportForm} sang thông tư %{newReportForm}. Xem BCTC năm %{years} %{link}.',
        CHANGE_LEGAL_REGULATION_2:
          'Năm %{yearChange}, Công ty đã thay đổi cách ghi nhận Báo cáo tài chính từ thông tư %{oldReportForm} sang thông tư %{newReportForm}.',
        HERE: 'vào đây',
        BACK_CHANGE_LEGAL_REGULATION:
          'Nhấn vào %{link} để xem Báo cáo tài chính trước năm %{yearChange}.',
        BACK: 'Trở về',
        CHANGE_FISCAL_END_YEAR:
          'Trong năm %{fiscalYearEndChangeYear}, Công ty đã thay đổi ngày kết thúc năm tài chính từ %{oldFiscalYearEnd} sang %{newFiscalYearEnd}.',
        dynamicTable: {
          AS_AT: 'Số cuối kỳ',
          FOR_THE_YEAR_ENDED: 'Số cuối kỳ',
          FY: 'FY',
          UNIT: 'Đơn Vị',
          AUDIT_STATUS: 'Tình Trạng Kiểm Toán',
          TYPE: 'Loại',
          LEGAL_REGULATION: 'Thông Tư',
          SOURCE: 'Nguồn',
          METHOD: 'Phương Pháp',
        },
        REQUEST_CONTACT_NOTE1:
          'Để biết thêm báo cáo tài chính hàng năm, vui lòng ',
        REQUEST_CONTACT_NOTE2: 'liên hệ với chúng tôi.',
      },
    },
  }),
)
